export default __webpack_public_path__ + "static/media/Celestiality-logo.00167bda.png";